<template>
  <div id="app">
    <navbar/>
    <router-view/>
    <foot/>
  </div>
</template>

<style>


#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
<script>
  import Navbar from "./components/shared/navbar";
  import Foot from "./components/shared/foot";
  export default {
    components: {Foot, Navbar}
  }
</script>